import { render, staticRenderFns } from "./MobileTabs.vue?vue&type=template&id=366bc265&"
import script from "./MobileTabs.vue?vue&type=script&lang=js&"
export * from "./MobileTabs.vue?vue&type=script&lang=js&"
import style0 from "./MobileTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports